/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarModel } from '../../models/calendar-model';

export interface ConsumerCalendarsGet$Params {
}

export function consumerCalendarsGet(http: HttpClient, rootUrl: string, params?: ConsumerCalendarsGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<Array<CalendarModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerCalendarsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<Array<CalendarModel>>;
    })
  );
}

consumerCalendarsGet.PATH = '/Consumer/Calendars';
